import { useState, useEffect } from "react";
import Header from "../../components/header/Header.tsx";
import Navbar from "../../components/navbar/Navbar.tsx";
import Footer from "../../components/footer/Footer.tsx";
// import { GrTrash } from "react-icons/gr";
import { FaArrowRightLong } from "react-icons/fa6";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../../components/spinner/Spinner.tsx";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { deleteFetcherWithData, getFetcher } from "../../../api/fetchers.ts";
import { endpoints } from "../../../api/endpoints.ts";
import { calculateDiscountedPrice } from "../../utils/functions.tsx";
import { Tooltip } from "flowbite-react";
import { useUser } from "../../context/UserContext.tsx";
import { IoCloseCircleOutline } from "react-icons/io5";
import { GoChevronLeft } from "react-icons/go";
import { parseStatics } from "../../function/parseStatics.tsx";
import { useLanguage } from "../../context/LanguageContext.tsx";
import { useCurrency } from "../../context/CurrencyContext.tsx";

interface B2B {
  id: string;
  name: string;
  ratio: number;
}

interface Product {
  id: string;
  name: string;
  brand: string;
  price: number;
  description: string;
  attributes: string;
  images: string;
  supplierId: string;
  categoryId: number;
  subCategoryId: number;
  stock: number;
  rating: number;
  discount: number;
  isFeatured: boolean;
  isFlash: boolean;
  coupon: number;
  status: boolean;
  createdAt: string;
  updatedAt: string;
  bulkDiscounts?: any;
  Supplier: any;
  code: any;
}

interface BasketItem {
  id: string;
  userId: string;
  productId: string;
  quantity: number;
  attributes: string;
  isCampaign: boolean;
  status: boolean;
  createdAt: string;
  updatedAt: string;
  product: Product;
  bulkDiscount: boolean;
}

interface BasketResponse {
  result: boolean;
  basketItems: BasketItem[];
}

const Basket = () => {
  const { t } = useLanguage();
  const { exchangeRate, currencySymbol } = useCurrency();
  const [basketData, setBasketData] = useState<BasketResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isConfirming, setIsConfirming] = useState(false);
  const { user } = useUser();
  const [userBusinessPackage, setUserBusinessPackage] = useState<B2B>();
  const navigate = useNavigate();

  const fetchBasketData = async () => {
    // @ts-ignore
    const defaultUserId = parseStatics(localStorage.getItem("defaultUserId"));
    setIsLoading(true);
    try {
      if (user) {
        const response = await getFetcher(endpoints.user.getUserBasket);
        if (response.result) {
          setBasketData(response);
        } else {
          setBasketData({ result: false, basketItems: [] });
          console.log(response.message);
        }
      } else {
        const response = await getFetcher(
          endpoints.user.getLocalBasket.replace(
            "{userId}",
            defaultUserId ? defaultUserId : ""
          )
        );
        if (response.result) {
          setBasketData(response);
        } else {
          setBasketData({ result: false, basketItems: [] });
          console.log(response.message);
        }
      }
      setError(null);
    } catch (error) {
      console.error("Error fetching basket data:", error);
      setError("Error fetching basket data");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchBusinessPackageData = async () => {
    if (user) {
      try {
        const businessPackage = await getFetcher(
          endpoints.user.getBusinessPackageById.replace(
            "{id}",
            user.businessPackageId
          )
        );
        if (businessPackage.result) {
          setUserBusinessPackage(businessPackage.businessPackage);
        }
      } catch (error) {
        console.error("Error fetching favorites:", error);
      }
    }
  };

  // Delete products from cart
  const removeItem = async (id: string, basketId: any) => {
    // @ts-ignore
    const defaultUserId = parseStatics(localStorage.getItem("defaultUserId"));
    try {
      if (user) {
        const response = await deleteFetcherWithData(
          endpoints.user.deleteProductBasket,
          { productId: id, basketId: basketId }
        );
        if (response && response.result) {
          setBasketData((prevData: any) => {
            return {
              ...prevData,
              basketItems: prevData.basketItems.filter(
                (item: any) => item.id !== id
              ),
            };
          });
          const localBasketItems = parseStatics(
            localStorage.getItem("basketItems") || "[]"
          );
          const updatedLocalBasketItems = localBasketItems.filter(
            (item: any) => item !== id
          );
          localStorage.setItem(
            "basketItems",
            JSON.stringify(updatedLocalBasketItems)
          );
          toast.success(t("toastMessage", "rate22"));
          setTimeout(async () => {
            await fetchBasketData();
          }, 2000);
        } else {
          console.log(response.message);
        }
      } else {
        const response = await deleteFetcherWithData(
          endpoints.user.deleteProductLocalBasket,
          { userId: defaultUserId, productId: basketId }
        );
        if (response && response.result) {
          setBasketData((prevData: any) => {
            return {
              ...prevData,
              basketItems: prevData.basketItems.filter(
                (item: any) => item.id !== id
              ),
            };
          });
          const localBasketItems = parseStatics(
            localStorage.getItem("basketItems") || "[]"
          );
          const updatedLocalBasketItems = localBasketItems.filter(
            (item: any) => item !== id
          );
          localStorage.setItem(
            "basketItems",
            JSON.stringify(updatedLocalBasketItems)
          );
          toast.success(t("toastMessage", "rate22"));
          setTimeout(async () => {
            window.location.reload();
          }, 1500);
          await fetchBasketData();
        } else {
          console.log(response.message);
        }
      }
    } catch (error) {
      console.error("Error removing item:", error);
      setError(
        "Ürün sepetten silinirken bir hata oluştu. Lütfen daha sonra tekrar deneyin."
      );
    }
  };

  const confirmBasket = async () => {
    try {
      setIsConfirming(true);
      setTimeout(async () => {
        toast.success(t("toastMessage", "rate23"));
        setBasketData(null);
        setIsConfirming(false);
        navigate("/safe-payment");
      }, 500);
    } catch (error) {
      console.error("Error confirming basket:", error);
      setError(
        "Sepet onaylanırken bir hata oluştu. Lütfen daha sonra tekrar deneyin."
      );
      setIsConfirming(false);
    }
  };

  useEffect(() => {
    const loadBasketData = async () => {
      await fetchBasketData();
      if (user) await fetchBusinessPackageData();
    };
    loadBasketData();
  }, [user]);

  if (isLoading) {
    return (
      <div className="flex flex-col min-h-screen">
        <Header />
        <Navbar />
        <main className="flex-grow flex justify-center items-center">
          <Spinner size="large" color="primary-color" />
        </main>
        <Footer />
      </div>
    );
  }

  // CUTTİNG TEXT
  const textCut = (text: string, length: number) => {
    return text.length > length ? text.substring(0, length) + "..." : text;
  };

  const calculateItemTotalPrice = (item: BasketItem): any => {
    const discountedPrice = calculateDiscountedPrice(
      item.product.price,
      item.product.discount,
      userBusinessPackage ? userBusinessPackage?.ratio : 0,
      exchangeRate
    );
    let totalPrice = discountedPrice * item.quantity;

    if (item.bulkDiscount) {
      const bulkDiscountedPrice = parseFloat(calculateBulkDiscount(item));
      totalPrice = bulkDiscountedPrice;
    }

    return totalPrice;
  };

  const calculateBulkDiscount = (item: BasketItem) => {
    const bulkDiscounts = item.product.bulkDiscounts
      ? item.product.bulkDiscounts
      : [];

    const discountPrice = calculateDiscountedPrice(
      item.product.price,
      item.product.discount,
      userBusinessPackage ? userBusinessPackage?.ratio : 0,
      exchangeRate
    );

    if (item.bulkDiscount) {
      const applicableBulkDiscount = bulkDiscounts
        .filter((bulk: any) => item.quantity >= bulk.quantity)
        .sort((a: any, b: any) => b.quantity - a.quantity)[0];

      if (applicableBulkDiscount) {
        const totalPrice = discountPrice * item.quantity;
        const totalDiscountAmount =
          (totalPrice * applicableBulkDiscount.discount) / 100; // Yüzde indirim hesaplandı
        const bulkPrice = (totalPrice - totalDiscountAmount).toFixed(2);

        return bulkPrice;
      } else {
        return (discountPrice * item.quantity).toFixed(2);
      }
    } else {
      return (discountPrice * item.quantity * exchangeRate).toFixed(2);
    }
  };

  const groupedBasketData: any = basketData?.basketItems?.reduce(
    (acc: Record<string, any[]>, item) => {
      const code = item.product?.code;
      if (!code) return acc;

      if (!acc[code]) {
        acc[code] = [];
      }
      acc[code].push(item);

      return acc;
    },
    {}
  );

  const calculateGroupedBulkDiscount = (basketItems: BasketItem[]): number => {
    const productGroups: {
      [key: string]: { totalQuantity: number; unitPrice: number };
    } = {};

    basketItems.forEach((item) => {
      const discountedUnitPrice = calculateDiscountedPrice(
        item.product.price,
        item.product.discount,
        userBusinessPackage ? userBusinessPackage.ratio : 0,
        exchangeRate
      );

      if (productGroups[item.product.code]) {
        productGroups[item.product.code].totalQuantity += item.quantity;
      } else {
        productGroups[item.product.code] = {
          totalQuantity: item.quantity,
          unitPrice: discountedUnitPrice,
        };
      }
    });

    let totalDiscountedPrice = 0;

    // Her ürün grubu için fiyat hesaplama
    Object.keys(productGroups).forEach((productCode) => {
      const { totalQuantity, unitPrice } = productGroups[productCode];
      

      // const bulkDiscountOptions = [
      //   { discount: 20, quantity: 10 },
      //   { discount: 27, quantity: 50 },
      //   { discount: 35, quantity: 100 },
      //   { discount: 45, quantity: 500 },
      // ];

      const bulkDiscountsArray = (basketData?.basketItems || []).flatMap(
        (item: any) => item.product?.bulkDiscounts?.map((discountItem: any) => ({
          quantity: discountItem.quantity,
          discount: discountItem.discount,
        })) || []
      );
      

      // Uygun toplu indirim bulma
      const applicableDiscount = bulkDiscountsArray
        .filter((discount) => totalQuantity >= discount.quantity)
        .sort((a, b) => b.quantity - a.quantity)[0];

      let productTotalPrice = unitPrice * totalQuantity;

      if (applicableDiscount) {
        const discountAmount =
          (productTotalPrice * applicableDiscount.discount) / 100;
        productTotalPrice -= discountAmount;
      }

      totalDiscountedPrice += productTotalPrice;
    });

    return parseFloat(totalDiscountedPrice.toFixed(2));
  };

  const totalPrice: number =

    groupedBasketData && Object.keys(groupedBasketData).length > 0 && basketData
      ? calculateGroupedBulkDiscount(basketData?.basketItems)
      : basketData?.basketItems.reduce(
          (sum, item) => sum + calculateItemTotalPrice(item),
          0
        ) || 0;


  const totalOriginalPrice: number =
    basketData?.basketItems.reduce(
      (sum, item) => sum + item.product.price * item.quantity * exchangeRate,
      0
    ) || 0;

  const totalDiscountAmount = totalOriginalPrice - totalPrice;

  const totalDiscountPercentage =
    (totalDiscountAmount / totalOriginalPrice) * 100;

  return (
    <div className="flex flex-col">
      {/* <Header />
      <Navbar /> */}
      <main className="flex-grow p-4 md:p-8">
        <div className="  mx-auto min-h-screen">
          {error ? (
            <div className="text-red-500 text-center">
              {error && <p>{t("basket", "noData")}</p>}
            </div>
          ) : (
            <div className=" flex justify-center flex-col lg:flex-row w-full 2xl:w-10/12 mx-auto gap-5 ">
              <div className="flex flex-col flex-[3]">
                {/* BASKET ITEMS */}
                <h1 className="text-[18px] text-[#191C1F]  border border-[#E4E7E9] border-b-0  font-[500] p-6 rounded-t">
                  {t("basket", "title")}
                </h1>
                <div className="w-full lg:w-full overflow-auto max-h-[calc(100vh-260px)] bg-white">
                  {basketData && basketData.basketItems.length > 0 ? (
                    <table className="table-auto w-full text-left border border-[#E4E7E9] rounded-b overflow-x-auto min-w-[700px]">
                      <thead>
                        <tr className="bg-gray-100 text-[13px] border-b-2 text-[#475156] font-light">
                          <th className=" px-2 sm:px-4 py-2"></th>
                          <th className=" px-2 sm:px-4 py-2">
                            {t("basket", "product")}
                          </th>
                          <th className=" px-2 sm:px-4 py-2">
                            {t("basket", "price")}
                          </th>
                          <th className=" px-2 sm:px-4 py-2">
                            {t("basket", "quantity")}
                          </th>
                          <th className=" px-2 sm:px-4 py-2">
                            {t("basket", "total")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {basketData.basketItems.map((item) => {
                          const attributes: any = item.attributes || {};
                          return (
                            <tr key={item.id} className="text-sm sm:text-base">
                              {/* Aksiyon */}
                              <td className=" px-2 sm:px-4 py-2 text-center">
                                <button
                                  onClick={() =>
                                    removeItem(item.product.id, item?.id)
                                  }
                                  className="text-[#929FA5] hover:text-red-600"
                                >
                                  <IoCloseCircleOutline size={20} />
                                </button>
                              </td>
                              {/* Ürün Bilgileri */}
                              <td className=" px-2 sm:px-4 py-2 text-[#141C3A]">
                                <div className="flex items-center gap-2">
                                  <img
                                    src={item.product.images[0]}
                                    alt={item.product.name}
                                    className="w-20 h-20 object-contain"
                                  />
                                  <div>
                                    <h3 className="text-[#191C1F] font-normal">
                                      {item.product.name}
                                    </h3>
                                    <p className="text-xs text-gray-500">
                                      {item.product.brand}
                                    </p>
                                    {/* Özellikler */}
                                    <div className="flex flex-wrap gap-1 mt-1">
                                      {attributes.Color && (
                                        <span
                                          style={{
                                            backgroundColor: attributes.Color,
                                          }}
                                          className="w-4 h-4 rounded-full border"
                                        ></span>
                                      )}
                                      {attributes.Size && (
                                        <span className="text-xs font-medium">
                                          {attributes.Size}
                                        </span>
                                      )}
                                      {attributes.Weight && (
                                        <span className="text-xs font-medium">
                                          {attributes.Weight}
                                        </span>
                                      )}
                                      {attributes.Ml && (
                                        <span className="text-xs font-medium">
                                          {attributes.Ml}
                                        </span>
                                      )}
                                      {item.bulkDiscount && (
                                        <span className="text-primary-color text-xs font-semibold">
                                          ({t("safePayment", "bulkDiscount")})
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </td>

                              {/* Fiyat */}
                              <td className=" px-2 sm:px-4 py-2 text-[13px]">
                                {currencySymbol}
                                {Number(
                                  calculateDiscountedPrice(
                                    item.product.price,
                                    item.product.discount,
                                    userBusinessPackage
                                      ? userBusinessPackage?.ratio
                                      : 0,
                                    exchangeRate
                                  )?.toFixed(2)
                                )}
                              </td>

                              {/* Adet */}
                              <td className=" px-2 sm:px-4 py-2 text-[13px]">
                                {item?.quantity}
                              </td>

                              {/* Toplam */}
                              <td className=" px-2 sm:px-4 py-2 font-semibold text-[13px]">
                                {item.bulkDiscount ? (
                                  <div className=" flex  gap-x-1">
                                    <p>{currencySymbol}</p>{" "}
                                    <p>{calculateBulkDiscount(item)}</p>
                                  </div>
                                ) : (
                                  <div className=" flex gap-x-1">
                                    <p>{currencySymbol}</p>{" "}
                                    <p>
                                      {calculateItemTotalPrice(item).toFixed(2)}
                                    </p>
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <p className="text-center text-gray-500 py-4">
                      Sepetinizde ürün bulunmamaktadır.
                    </p>
                  )}
                  <div className=" border border-t-0 p-4">
                    <button
                      onClick={() => navigate("/")}
                      className=" border-[3px] border-[#141C3A] p-2 flex items-center justify-center hover:bg-primary-color hover:text-yellow-color transition-all font-poppins font-semibold text-[13px]"
                    >
                      <GoChevronLeft size={24} />
                      <p>{t("basket", "button")}</p>{" "}
                    </button>
                  </div>
                </div>
              </div>

              {/* BASKET SUMMARY */}
              <div className=" flex-1 border p-4 rounded">
                {basketData && basketData.basketItems.length > 0 && (
                  <div className="w-full flex flex-col items-center justify-start">
                    <div className="bg-white p-4  w-full h-full">
                      <h2 className="text-[17px] font-semibold text-primary-color mb-4">
                        {t("basket", "basketSummery")}
                      </h2>
                      <div className="mb-4 flex flex-col gap-y-2 text-[13px]">
                        {totalDiscountAmount > 0 && (
                          <p className="flex justify-between">
                            <span className="text-color-bold-gray">
                              {t("basket", "discount")}
                            </span>
                            <span className=" text-white font-bold text-xs p-1  rounded flex justify-center items-center bg-green-700">
                              %{totalDiscountPercentage.toFixed(2)}
                            </span>
                          </p>
                        )}
                        <p className="flex justify-between">
                          <span className="text-color-bold-gray">
                            {t("basket", "cargo")}
                          </span>
                          <span className="flex text-end">
                            {t("basket", "cargoTotal")}
                          </span>
                        </p>
                      </div>
                      {/*BASKET INFO TABLE*/}
                      <div className="overflow-x-auto my-4 ">
                        <ul className="">
                          <div className=" flex justify-between items-center text-[13px] border-b-2 text-[#475156] font-[500]">
                            <div>
                              <p> {t("basket", "product")} </p>
                            </div>
                            <div>
                              <p> {t("basket", "quantity")} </p>
                            </div>
                            <div>
                              <p> {t("basket", "price")} </p>
                            </div>
                          </div>
                          {basketData.basketItems.map(
                            (item: any, index: number) => (
                              <li
                                className={` flex justify-between items-center py-4 w-full mt-4 p-2 border-b text-[13px]  `}
                                key={index}
                              >
                                <div className=" w-32 select-none ">
                                  <Tooltip
                                    content={item.product.name}
                                    style="light"
                                  >
                                    <p className="   text-color-bold-gray">
                                      {textCut(item.product.name, 10)}
                                    </p>
                                  </Tooltip>
                                </div>
                                <div className="  w-24 flex justify-start ml-8 pl-4 items-center gap-x-4 ">
                                  <span> x </span>
                                  <span>{item.quantity}</span>
                                </div>
                                <div className=" w-24 flex justify-end ">
                                  <span className="text-color-bold-gray font-semibold flex gap-x-1  ">
                                    {currencySymbol}
                                    {item?.bulkDiscount == true
                                      ? parseFloat(
                                          calculateBulkDiscount(item)
                                        ).toFixed(2)
                                      : parseFloat(
                                          calculateItemTotalPrice(item)
                                        ).toFixed(2)}
                                  </span>
                                </div>
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                      <p className="flex justify-between flex-col md:flex-row">
                        <span className="text-color-bold-gray">
                          {t("basket", "total")}
                        </span>
                        <div className=" flex gap-x-2">
                          <span className=" line-through text-color-bold-gray font-bold">
                            {" "}
                            {currencySymbol}
                            {totalOriginalPrice?.toFixed(2)}
                          </span>
                          <span className=" text-primary-color font-bold">
                            {currencySymbol}
                            {totalPrice?.toFixed(2)}
                          </span>
                        </div>
                      </p>
                    </div>
                    {/* CONFIRM BUTTON */}
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        confirmBasket();
                      }}
                      className="bg-yellow-color text-white px-4 py-2 rounded w-full flex justify-between items-center mt-4 font-poppins font-semibold"
                      to="/safe-payment"
                    >
                      {isConfirming ? (
                        <div className="flex items-center gap-2 max-h-6 w-full justify-center">
                          <Spinner size="small" color="white" />
                        </div>
                      ) : (
                        <>
                          <span className="flex-grow text-center">
                            {t("basket", "successButton")}
                          </span>
                          <FaArrowRightLong className="w-4 h-4 ml-2" />
                        </>
                      )}
                    </Link>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </main>
      {/* <Footer /> */}
      <ToastContainer />
    </div>
  );
};

export default Basket;
